export const emphasisLevelLabels = [
  "reduced",
  "moderate",
  "strong",
  "x-strong",
];

export const volumeLevelLabels = [
  "silent",
  "x-soft",
  "soft",
  "medium",
  "loud",
  "x-loud",
];

export const pitchOptions = ["st", "Hz"];
export const timeOptions = ["ms", "s"];

export const prosodyAttributes = [
  "volume",
  "rate",
  "duration",
  "pitch",
  "contour",
];

export const ssmlTagsAndAttributes = [
  { name: "voice", attr: "name" },
  { name: "lang", attr: "language" },
  { name: "break", attr: "time" },
  { name: "prosody", attr: "volume" },
  { name: "prosody", attr: "rate" },
  { name: "prosody", attr: "duration" },
  { name: "prosody", attr: "pitch" },
  { name: "prosody", attr: "contour" },
  { name: "emphasis", attr: "level" },
  { name: "say-as", attr: "interpret-as" },
  { name: "phoneme", attr: "alphabet" },
];

export const intensityLevelLabels = [
  "x-weak",
  "weak",
  "medium",
  "strong",
  "x-strong",
];

export const accentLevelLabels = [
  "none",
  "x-weak",
  "weak",
  "medium",
  "strong",
  "x-strong",
];
